import React, { useState, useEffect } from "react";

const PorDisponibilidad = () => {
  const [loading, setLoading] = useState(true);

  const handleIframeLoad = () => {
    setLoading(false); // Ocultar el mensaje de "Cargando" cuando el iframe termine de cargar
  };

  useEffect(() => {
    // Agregar el script de Google Tag Manager dinámicamente
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-10941083434";
    document.head.appendChild(script);

    // Configurar Google Analytics
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "AW-10941083434");

    // Agregar el evento de conversión
    gtag("event", "conversion", {
      send_to: "AW-10941083434/8tqJCLv84scaEKrejuEo",
      value: 1.0,
      currency: "CLP",
    });

    // Agregar el script para escuchar eventos de mensaje
    const eventScript = document.createElement("script");
    eventScript.innerHTML = `
      var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
      var eventer = window[eventMethod];
      var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
      eventer(messageEvent, function (e) {
        if (e.data === "conversion_event" || e.message === "conversion_event") { 
          console.log("Señal de agendamiento enviada por Reservo");
          gtag("event", "conversion", {
            send_to: "AW-10941083434/8tqJCLv84scaEKrejuEo",
            value: 1.0,
            currency: "CLP",
          });
        }
      });
    `;
    document.body.appendChild(eventScript);

    return () => {
      // Limpiar los scripts si el componente se desmonta
      document.head.removeChild(script);
      document.body.removeChild(eventScript);
    };
  }, []);

  return (
    <div className="container my-5">
      <h1 className="text-center mb-4">Reserva por Especialidad</h1>

      {loading && <p className="text-center">Cargando...</p>}

      <iframe
        style={{
          overflow: "hidden",
          borderRadius: "10px",
          marginBottom: "20px",
          height: "500px", // Ajuste para dispositivos móviles
        }}
        src="https://agendamiento.reservo.cl/makereserva/agenda/O016aue0L0F1I39j3W12vKx1p258of"
        width="100%"
        frameBorder="0"
        title="Reserva por disponibilidad"
        onLoad={handleIframeLoad} // Detectar cuando el iframe ha terminado de cargar
      ></iframe>

      <p className="text-center">
        <a href="https://www.reservo.cl" target="_blank" rel="noopener noreferrer">
          Powered by Reservo
        </a>
      </p>
    </div>
  );
};

export default PorDisponibilidad;